import { type FC, useEffect } from 'react'
import { useRotaPatternDescription } from 'screens/Rostering/hooks/useRotaPatternDescription'
import { FrequencyResult } from '../../formComponents'
import type { ModalSectionProps, RotaPatternModalType } from '../utils'

export const FrequencyResultSection: FC<
  ModalSectionProps & { type?: RotaPatternModalType }
> = ({ form, formData, type }) => {
  const hasTimeWindow = formData?.startTime && formData?.endTime

  const { generatePattern, isLoadingGenerate, generatePatternMessage } =
    useRotaPatternDescription({ type })

  const isFormTouched = !!form?.getFieldValue('patternStart')

  useEffect(() => {
    if (hasTimeWindow && isFormTouched) {
      generatePattern(formData as any)
    }
  }, [isFormTouched, formData])

  if (!hasTimeWindow || !generatePatternMessage) {
    return null
  }

  return (
    <FrequencyResult
      message={generatePatternMessage}
      isLoading={isLoadingGenerate}
    />
  )
}
